import { VFC } from 'react'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { EDIT_COMPANY, EDIT_PROFILE, EDIT_SETTLER } from 'src/utils/routes'
import { Link } from 'src/elements/Link'
import { black, contributionGray, orange } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { FormSpacer } from './common'

export const ProfileTabs: VFC = () => {
  const { asPath } = useRouter()

  return (
    <>
      <Tabs>
        <TabItem href={EDIT_PROFILE} $isCurrent={asPath.includes(EDIT_PROFILE)}>
          <p>個人情報</p>
        </TabItem>
        <TabItem href={EDIT_COMPANY} $isCurrent={asPath.includes(EDIT_COMPANY)}>
          <p>企業情報</p>
        </TabItem>
        <TabItem href={EDIT_SETTLER} $isCurrent={asPath.includes(EDIT_SETTLER)}>
          <p>決裁者情報</p>
        </TabItem>
      </Tabs>
      <FormSpacer marginTop={-1} marginBottom={-1} />
    </>
  )
}

const Tabs = styled.div`
  display: flex;
  padding: 0px 10px;
  max-width: 700px;
  margin: auto;
`

const TabItem = styled(Link)<{ $isCurrent: boolean }>`
  max-width: 120px;
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: ${fontWeightBold};
  text-align: center;
  margin-right: 30px;
  color: ${contributionGray};

  p {
    padding: 16px;
  }

  :hover,
  :focus {
    color: ${orange};
  }

  ${({ $isCurrent }) =>
    $isCurrent &&
    `
      border-bottom: 3px solid ${orange};
      color: ${black};
    `};
`
